import React from "react";
import { Paper, Text } from "@mantine/core";
import { useAppSelector } from "../../../../app/hooks";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import {
  selectAdvancedCopySourceCeilingGridPixPaths,
  selectAdvancedCopySourceViewerPixPolygons,
} from "./advancedCopyDevicesSelectors";

export const AdvancedCopyDevicesSourceViewer: React.FC = () => {
  const rotation = useAppSelector((state) => state.design.rotation);
  const polygons = useAppSelector(selectAdvancedCopySourceViewerPixPolygons);
  const paths = useAppSelector(selectAdvancedCopySourceCeilingGridPixPaths);

  if (polygons.length === 0) {
    return (
      <Paper
        bg="gray.0"
        radius="md"
        p="md"
        style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Text size="sm" c="dimmed">
          Ingen romgeometri tilgjengelig
        </Text>
      </Paper>
    );
  }

  return (
    <Paper bg="gray.0" radius="md" p="md" style={{ flex: 1, minHeight: 320 }}>
      <DeckBimViewer flip2dCoordinate={true} angle={rotation} paths={paths} polygons={polygons} />
    </Paper>
  );
};
